var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlugIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3C3732",
    d: "M47.25 38.964c0 .653-.529 1.182-1.181 1.182s-1.182-.53-1.182-1.182V2.361l-42.524.001-.001 42.526 43.706-.011c.651.001 1.179.528 1.18 1.178.001.653-.526 1.183-1.179 1.185l-43.706.01C1.059 47.249.002 46.192 0 44.888V2.361C.002 1.057 1.058.001 2.363 0h42.524c1.305.001 2.361 1.057 2.363 2.361v36.603zm-23.625-3.526c6.524 0 11.813-5.416 11.813-12.094-.008-6.676-5.292-12.087-11.813-12.094-6.524 0-11.813 5.415-11.813 12.094 0 6.678 5.29 12.093 11.813 12.093zm0 2.25c-7.767 0-14.063-6.422-14.063-14.344S15.86 9 23.626 9c7.766 0 14.063 6.422 14.063 14.344S31.39 37.687 23.624 37.687zm-4.5-16.876c1.243 0 2.25 1.008 2.25 2.25 0 1.243-1.007 2.25-2.25 2.25-1.242 0-2.25-1.007-2.25-2.25 0-1.242 1.008-2.25 2.25-2.25zm11.25 2.25c0-1.242-1.007-2.25-2.25-2.25s-2.25 1.008-2.25 2.25c0 1.243 1.007 2.25 2.25 2.25s2.25-1.007 2.25-2.25z",
    transform: "translate(-464 -1030) translate(444 1010) translate(16 16) translate(4.5 4.5) translate(7.875 7.875)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugIcon);
export default __webpack_public_path__ + "static/media/plug_icon.af3862994d51ebc8fccde359beb0ebca.svg";
export { ForwardRef as ReactComponent };